

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NewLoanApplication = () => {
  const [selectedTab, setSelectedTab] = useState('UPAS');
  const [selectedRefinanceTab, setSelectedRefinanceTab] =
    useState('firstRefinance');
  const [isFormVisible, setIsFormVisible] = useState(true);
  const navigate = useNavigate();

  const handleTabChange = e => {
    setSelectedTab(e.target.value);
  };
  const handleRefinanceTabChange = e => {
    setSelectedRefinanceTab(e.target.value);
  };


  const handleClose = () => {
    setIsFormVisible(false);
    navigate('/dashboard'); // Or any other route
  };

  const handleNext = () => {
    setIsFormVisible(false);
    if (selectedTab === "UPAS") {
      navigate('/upas');
    } 
   else if (selectedRefinanceTab === 'firstRefinance') {
     navigate('/firstRefinance');
   } else if (selectedRefinanceTab === 'secondRefinance') {
     navigate('/secondRefinance');
   } else {
     navigate('/dashboard');
   }
      
    // console.log('Next button clicked');
  };

  return (
    <>
      {isFormVisible && (
        <div className="md:px-10 px-2 md:py-10 py-6">
          {/* title header */}
          <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg">
            <div className="flex justify-between">
              <div>
                <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
                  Apply for Your UPAS/LC Today
                </h2>
                <p className="md:mb-2 text-xs md:text-sm text-white">
                  Quick, Easy, and Secure – Get the Funds You Need Fast
                </p>
              </div>

              {/* Close button */}
              {/* <button
                onClick={handleClose}
                className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
              >
                &times;
              </button> */}
            </div>
          </div>

          {/* Radio tabs */}
          <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 h-screen">
            <h2 className="text-headerBtn heading xl:text-xl mb-4 xl:mb-8 text-lg">
              Select your Apply Type
            </h2>
            <div className="flex space-x-0 mb-6 border-2 border-headerBtn p-1 rounded-md">
              <label
                className={` flex items-center space-x-2 cursor-pointer py-2 px-2 rounded-md w-36 ${
                  selectedTab === 'UPAS'
                    ? 'bg-headerBtn text-white'
                    : 'bg-AboutUsBg '
                }`}
              >
                <input
                  type="radio"
                  name="loanType"
                  value="UPAS"
                  checked={selectedTab === 'UPAS'}
                  onChange={handleTabChange}
                  className="hidden peer"
                />
                <div className="w-4 h-4 border-2 ring-2 ring-headerBtn border-white rounded-full peer-checked:bg-headerBtn"></div>
                <span className="p-0.5 text-sm lg:text-base ">UPAS</span>
              </label>
              <label
                className={`flex items-center space-x-2 cursor-pointer py-2 px-2 rounded-md w-36 ${
                  selectedTab === 'Refinance'
                    ? 'bg-headerBtn text-white'
                    : 'bg-AboutUsBg '
                }`}
                onClick={() => setSelectedTab('Refinance')}
              >
                <input
                  type="radio"
                  name="loanType"
                  value="Refinance"
                  checked={selectedTab === 'Refinance'}
                  onChange={handleTabChange}
                  className="hidden"
                />
                <div className="w-4 h-4 border-2 ring-2 ring-headerBtn border-white rounded-full peer-checked:bg-headerBtn"></div>
                <span className="p-0.5 text-sm lg:text-base">Refinance</span>
              </label>
            </div>

            {selectedTab === 'Refinance' && (
              <div>
                <div className="flex space-x-0 mb-6 border-2 border-headerBtn p-1 rounded-md">
                  <label
                    className={` flex items-center space-x-2 cursor-pointer py-2 px-2 rounded-md ${
                      selectedRefinanceTab === 'firstRefinance'
                        ? 'bg-headerBtn text-white'
                        : 'bg-AboutUsBg '
                    }`}
                  >
                    <input
                      type="radio"
                      name="refinanceSelect"
                      value="firstRefinance"
                      checked={selectedRefinanceTab === 'firstRefinance'}
                      onChange={handleRefinanceTabChange}
                      className="hidden peer"
                    />
                    <div className="w-4 h-4 border-2 ring-2 ring-headerBtn border-white rounded-full peer-checked:bg-headerBtn"></div>
                    <span className="p-0.5 xl:text-sm text-xs lg:text-base ">
                      First Refinance
                    </span>
                  </label>
                  <label
                    className={`flex items-center space-x-2 cursor-pointer py-2 px-2 rounded-md  ${
                      selectedRefinanceTab === 'secondRefinance'
                        ? 'bg-headerBtn text-white'
                        : 'bg-AboutUsBg '
                    }`}
                  >
                    <input
                      type="radio"
                      name="refinanceSelect"
                      value="secondRefinance"
                      checked={selectedRefinanceTab === 'secondRefinance'}
                      onChange={handleRefinanceTabChange}
                      className="hidden"
                    />
                    <div className="w-4 h-4 border-2 ring-2 ring-headerBtn border-white rounded-full peer-checked:bg-headerBtn"></div>
                    <span className="p-0.5 xl:text-sm text-xs lg:text-base">
                      Second Refinance
                    </span>
                  </label>
                </div>
              </div>
            )}

            {/* Next and Close buttons */}
            <div className="flex space-x-4">
              <button
                onClick={handleNext}
                className="bg-headerBtn text-white py-2 px-6 rounded-lg hover:bg-btnHover transition duration-300"
              >
                Next &gt;
              </button>
              {/* <button
                onClick={handleClose}
                className=" text-headerBtn border border-headerBtn py-2 px-6 rounded-lg hover:bg-btnHover hover:text-white transition duration-300"
              >
                Close
              </button> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewLoanApplication;
